import { ISearchOrdersSettingsData } from './ISearchOrdersSettingsData';
import { createDefaultVendorOrderData, IVendorOrderData, IVendorOrderResponse } from './IVendorOrders';

export interface IVendorPayoffsResponse {
  payoffRequests: IVendorPayoffResponse[];
  page: number;
  pageSize: number;
  total: number;
}

export interface IVendorPayoffsData {
  payoffRequests: IVendorPayoffData[];
  total: number;
}

export const createDefaultVendorPayoffsData = (): IVendorPayoffsData => ({
  payoffRequests: [],
  total: 1,
});

export const convertFromVendorPayoffsResponseToVendorPayoffsData = (
  data: IVendorPayoffsResponse
): IVendorPayoffsData => ({
  payoffRequests: data.payoffRequests,
  total: data.total,
});

export const convertFromVendorPayoffsDataAndSearchSettingsToVendorPayoffsResponse = (
  data: IVendorPayoffsData,
  searchSettings: ISearchOrdersSettingsData
): IVendorPayoffsResponse => ({
  payoffRequests: data.payoffRequests,
  page: searchSettings.page,
  pageSize: searchSettings.pageSize,
  total: data.total,
});

export interface IVendorPayoffResponse extends Omit<IVendorOrderResponse, 'titleSearchId'> {
  payoffRequestId: string;
  eta?: string;
}

export interface IVendorPayoffData extends Omit<IVendorOrderData, 'titleSearchId'> {
  payoffRequestId: string;
  eta?: string;
}

export const createDefaultVendorPayoffData = (): IVendorPayoffData => {
  const { titleSearchId, ...rest } = createDefaultVendorOrderData();
  return {
    ...rest,
    payoffRequestId: '',
  };
};

export const convertFromVendorPayoffResponseToVendorPayoffData = (data: IVendorPayoffResponse): IVendorPayoffData =>
  data;
export const convertFromVendorPayoffDataToVendorPayoffResponse = (data: IVendorPayoffData): IVendorPayoffResponse =>
  data;
